export default "__VITE_ASSET__CyGek9p$__"